export const isImageFile = (fileType: string) => {
    const regex = /^image/;
    return regex.test(fileType);
};
